import React from 'react';
import { PieChart, Pie, Tooltip, Cell } from 'recharts';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#FF6384', '#36A2EB', '#FFCE56'];

const PieChartComponent = ({ questionText, responseCounts, disableAnimation = false, height = 350 }) => {

    const total = responseCounts.reduce((sum, { count }) => sum + count, 0);

    const data = responseCounts.map(({ option, count }) => ({
      name: option,
      value: count,
      percentage: ((count / total) * 100).toFixed(2),
    }));

    const allSame = data.length === 1 || data.every((d) => d.value === data[0].value);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box sx={{ textAlign: 'center', mt: 2 }}>
      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        p: 2,
        flexDirection: isMobile ? 'column' : 'row',
        width: '100%',
        height: isMobile ? 'auto' : height,
      }}>
        <PieChart width={400} height={isMobile ? (height * 1.15) / 2 : height * 1.15}>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            labelLine={false}
            outerRadius={isMobile ? "70%" : "60%"}
            fill="#8884d8"
            dataKey="value"
            label="value"
            animationDuration={disableAnimation ? 0 : 800}
            stroke={allSame ? 'none' : '#ffffff'}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip 
              formatter={(value, name, { payload }) => [`${payload.percentage}%`, name]}
            />
        </PieChart>

        <Box sx={{ mt: isMobile ? 2 : 0, ml: isMobile ? 0 : 5, mb: isMobile ? 0 : 20 ,textAlign: 'center' }}>
          {data.map((entry, index) => (
            <div key={`legend-${index}`} style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
              <span style={{ display: 'inline-block', width: 12, height: 12, backgroundColor: COLORS[index % COLORS.length], marginRight: 8 }}></span>
              <Typography variant="body2">{entry.name}</Typography>
            </div>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default PieChartComponent;
